// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2eUDn","expandIcon":"AccordionButton_expandIcon__2No1v","expanded":"AccordionButton_expanded__m7L95"};